import type { FilterValues, SetValueProps } from '@src/components/FilterDropDown/FilterDropDown.interfaces';

/** Restore a removed tag to its first-visit value; period mode and range reset together. */
export const restoreClearedReportFilters = (
  change: SetValueProps | SetValueProps[],
  fields: { RELATIVE: string; DATE_RANGE: string; GROUP_BY: string },
  createDefaults: () => FilterValues,
): SetValueProps[] => {
  if (Array.isArray(change)) return change;
  const periodKeys = [fields.RELATIVE, fields.DATE_RANGE];
  const keys = periodKeys.includes(change.key) ? periodKeys : [change.key];
  if (change.value != null || (!periodKeys.includes(change.key) && change.key !== fields.GROUP_BY)) {
    return [change];
  }
  const defaults = createDefaults();
  return keys.map(key => ({ ...defaults[key], key }));
};
